import React, { useMemo } from 'react';
import ApiScaleGrid from '../Escala Medica/ApiScaleGrid';
import {
	EscalaEnfermagemPdfPreview,
	exportarPdfGridEscalaEnfermagem,
	SHOW_ESCALA_ENFERMAGEM_PDF_PREVIEW,
} from './PDFgridEnfermagem';

const obterTexto = (valor) => {
	if (valor == null) return '';
	if (typeof valor === 'object') {
		return (
			obterTexto(valor.nome) ||
			obterTexto(valor.nome_exibicao) ||
			obterTexto(valor.descricao) ||
			obterTexto(valor.label)
		);
	}

	const texto = String(valor).trim();
	return texto && !/^\d+$/.test(texto) ? texto : '';
};

const construirCategoriasPorId = (payload = {}) => {
	const categoriasPorId = {};
	[
		payload?.facetas?.categorias,
		payload?.categorias,
		payload?.catalogos?.categorias,
		payload?.visualizacao?.categorias,
	].forEach((categorias) => {
		if (!Array.isArray(categorias)) return;

		categorias.forEach((categoria) => {
			const id =
				categoria?.id ??
				categoria?.categoria_id ??
				categoria?.codigo ??
				categoria?.value;
			const nome = obterTexto(categoria);
			if (id != null && nome) categoriasPorId[String(id)] = nome;
		});
	});

	return categoriasPorId;
};

const obterCategoria = (item = {}, categoriasPorId = {}) =>
	obterTexto(
		item?.categoria?.nome ||
			item?.categoria ||
			item?.nome_categoria ||
			item?.categoria_nome ||
			item?.resumo?.categoria ||
			item?.especialidade?.nome ||
			item?.especialidade ||
			categoriasPorId[
				String(
					item?.categoria_id ||
						item?.edicao?.categoria_id ||
						item?.profissional_por_cpf?.categoria_id ||
						item?.vinculo_profissional?.categoria_id ||
						'',
				)
			],
	);

const adaptarItemParaGradeCompartilhada = (item, categoriasPorId) => {
	const categoria = obterCategoria(item, categoriasPorId);
	if (!categoria) return item;

	return {
		...item,
		especialidade: item?.especialidade || categoria,
		nome_especialidade: item?.nome_especialidade || categoria,
		resumo: {
			...(item?.resumo || {}),
			especialidade: item?.resumo?.especialidade || categoria,
		},
	};
};

const adaptarPayloadEnfermagem = (payload = {}) => {
	const categoriasPorId = construirCategoriasPorId(payload);
	const adaptarItem = (item) =>
		adaptarItemParaGradeCompartilhada(item, categoriasPorId);
	const visualizacao = payload?.visualizacao || payload?.grade || {};

	return {
		...payload,
		itens: (payload?.itens || []).map(adaptarItem),
		visualizacao: {
			...visualizacao,
			setores: (visualizacao?.setores || []).map((setor) => ({
				...setor,
				linhas: (setor?.linhas || []).map((linha) => ({
					...linha,
					celulas: (linha?.celulas || []).map((celula) => ({
						...celula,
						cards: Array.isArray(celula?.cards)
							? celula.cards.map(adaptarItem)
							: celula?.cards,
					})),
				})),
			})),
		},
	};
};

/**
 * A enfermagem usa a mesma base visual da grade médica. A única diferença
 * intencional é a adaptação dos dados. A grade continua usando a navegação
 * semanal compartilhada, recortando no cliente as colunas mensais da API.
 */
function ApiScaleGridEnfermagem({
	payload,
	onEditItem,
	canManageItems = true,
}) {
	const payloadAdaptado = useMemo(
		() => adaptarPayloadEnfermagem(payload),
		[payload],
	);

	return (
		<ApiScaleGrid
			payload={payloadAdaptado}
			onEditItem={onEditItem}
			canManageItems={canManageItems}
			canModifyItems={false}
			preservarAlturaNomeSetor
			agruparPorEspecialidade
			rotuloAgrupamento='Categoria'
			seguirTituloAgrupamentoNoScroll
			abreviarTurnoCompacto
			compactarNomeProfissionalNoCard
			regime={
				payloadAdaptado?.contexto?.regime ||
				payloadAdaptado?.contexto_competencia?.regime ||
				''
			}
			habilitarPreviewPdf={SHOW_ESCALA_ENFERMAGEM_PDF_PREVIEW}
			PdfPreviewCustom={EscalaEnfermagemPdfPreview}
			exportarPdfCustom={exportarPdfGridEscalaEnfermagem}
		/>
	);
}

export default ApiScaleGridEnfermagem;
